const ProductManagementConstant = {
    PRODUCT_LIST: 'PRODUCT_LIST',
    EDITION_LIST: 'EDITION_LIST',
    VERSION_LIST: 'VERSION_LIST',
    
    METHOD_PRODUCT: {
        GET_LIST_PRODUCT: 'GET_LIST_PRODUCT',
        GET_LIST_EDITION: 'GET_LIST_EDITION',
        CREATE_AND_UPDATE_PRODUCT_LIST: 'CREATE_AND_UPDATE_PRODUCT_LIST',
        CREATE_AND_UPDATE_EDITION_LIST: 'CREATE_AND_UPDATE_EDITION_LIST',
        CREATE_VERSION: 'CREATE_VERSION',
        GET_VERSION_BY_ID: 'GET_VERSION_BY_ID',
        UPDATE_VERSION: 'UPDATE_VERSION',
        COPY_VERSION: 'COPY_VERSION',
        GET_PRODUCT_BY_ID: 'GET_PRODUCT_BY_ID'

    },
    STATUS: {
        INACTIVE: 0,
        ON_SALES: 1,
        INTERNAL_SALE: 2
    },

    MAX_LENGTH_NAME: 200,
    CREATE_VERSION: 'CREATE_VERSION',
    NAME: {
        EDITION: 'エディション',
        VERSION: 'バージョン',
        PRODUCT: '製品'
    },
    TEXTBOX_SETTING_LINCENSE_KEY : 'OpenAIライセンスキー',
    TEXTBOX_SETTING_SYSTEM_PROMPT : 'システムプロンプト',
    TEXTBOX_SETTING_INTERATOR_SYSTEM_PROMPT : 'イテレーター用プロンプト',
    USAGE: {
        PRODUCT: 'PRODUCT',
        EDITION: 'EDITION',
        VERSION: 'VERSION'
    },
    ADVANCED_SETTING_KEY_MAP: {
        VALUE: 'value',
        PRICE: 'price',
    }
}

export default ProductManagementConstant;